import { Link } from 'react-router-dom';
import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-start pt-24 md:pt-32 pb-12 md:pb-20">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto flex flex-col items-center">
        <div className="flex items-center gap-2 mb-6">
          <span className="px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full font-label">
            实时更新中
          </span>
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-foreground-950 text-center leading-tight tracking-tight">
          51黑料
          <br />
          吃瓜网
        </h1>

        <p className="mt-6 md:mt-8 text-base md:text-lg text-foreground-600 text-center max-w-xl leading-relaxed">
          汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源
          <br className="hidden md:block" />
          深度起底热门事件真相，24小时不打烊实时推送最新大瓜
        </p>

        <div className="flex items-center gap-3 mt-8 md:mt-10">
          <Link
            to="/category/star-scandal"
            className="px-7 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap font-label"
          >
            立即吃瓜
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 bg-background-50 text-foreground-950 text-sm font-medium rounded-full border-2 border-foreground-200 hover:border-foreground-400 transition-colors duration-200 whitespace-nowrap font-label"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-8 md:gap-12 mt-10 md:mt-12">
          {heroStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto mt-12 md:mt-16">
        <div className="relative w-full rounded-2xl overflow-hidden" style={{ aspectRatio: '16/7' as string }}>
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20dramatic%20red%20carpet%20event%20scene%20with%20flashing%20camera%20lights%20and%20blurred%20silhouettes%2C%20dark%20moody%20atmosphere%20with%20deep%20shadows%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20warm%20amber%20spotlights%20cutting%20through%20darkness%2C%20mysterious%20and%20glamorous%20ambiance%2C%20high%20contrast%20black%20and%20warm%20tones%2C%20artistic%20composition%20with%20negative%20space&width=1800&height=788&seq=hero-main-bg&orientation=landscape"
            alt="51黑料吃瓜网 - 娱乐圈爆料现场氛围"
            title="51黑料吃瓜网 - 娱乐圈爆料现场"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}